export const CLICK_MENU = 'CLICK_MENU';
export const CLICK_ITEM = 'CLICK_ITEM';
export const HOVER_ITEM = 'HOVER_ITEM';
export const RESET = 'RESET';

export default (state, action) => {
  const { type, payload = {} } = action;
  const { menu, content, selected } = payload;

  switch (type) {
    case CLICK_MENU: {
      return {
        ...state,
        content,
        menu,
      };
    }
    case CLICK_ITEM: {
      return {
        ...state,
        content,
        selected,
      };
    }
    case HOVER_ITEM: {
      return {
        ...state,
        content,
      };
    }
    case RESET: {
      return {
        ...state,
        content: {},
        menu: '',
        selected: [],
      };
    }

    default:
      return state;
  }
};
